export default __webpack_public_path__ + "static/media/ic_loyalty.fbcd9e3f.svg";